
import { defineComponent } from 'vue';

import BurgerButton from '@/components/App/BurgerButton.vue';
import PersistentButton from './PersistentButton.vue';
import Button from '@/models/ButtonModel';
import PersistentAnswerField from '@/components/PersistentMenu/PersistentAnswerField.vue';

export default defineComponent({
	name: 'persistent-menu',

	components: {
		BurgerButton,
		PersistentButton,
		PersistentAnswerField
	},

	props: {
		persistentMenu: {
			type: Array as () => Array<Button>,
			required: true
		},

		isShowAnswerField: {
			type: Boolean
		},

		isShowBranding: {
			type: Boolean,
			required: true
		}
	},

	emits: ['send-message'],

	data: () => ({
		menuOpened: false
	}),

	updated() {
		console.log(this.isShowAnswerField, 'isShowAnswerField');
	},

	computed: {
		href(): string {
			return window.location.origin;
		},
		poweredBy(): string {
			const hostname = window.location.hostname.split('.')[0];
			switch (hostname) {
				case 'borisbot':
					return 'BorisBot';
				case 'buddybot':
					return 'BuddyBot';
				default:
					return 'BorisBot';
			}
		}
	},

	methods: {
		sendMessage(text: string) {
			this.$emit('send-message', { text });
		},
		clickOnButton(button: Button) {
			const text = button.command ?? button.text;
			const type = button.command ? 'command' : 'text-my';

			const payload = {
				text,
				textBody: button.text,
				params: button.params,
				type,
				link: button.link,

				// Тут у нас может быть action либо какой нибудь другой тип в будущем
				buttonType: button.type
			};

			this.$emit('send-message', payload);
		}
	}
});
